import './bootstrap'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import mainStore from './store'
import {VueTables, ServerTable, ClientTable, Event} from 'vue-tables-2';
import VueToastr from '@deveodk/vue-toastr'
import {Pagination} from 'vue-pagination-2';
import Multiselect from 'vue-multiselect'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import VueNumberInput from '@chenfengyuan/vue-number-input';
import swal from 'sweetalert';
import money from 'v-money';
import CKEditor from '@ckeditor/ckeditor5-vue';

Vue.use(CKEditor);

//Mask to inputs
import VueMask from 'v-mask'
Vue.use(VueMask);

//Money Mask for inputs
Vue.use(money, {precision: 2})

const translation = {
    filterBy: 'Filtrar por {column}',
    count: 'Mostrando {from} de {to} até {count} de registros',
    filter: 'Pesquisar:',
    filterPlaceholder: 'Pesquisar',
    limit: 'Registros:',
    noResults: 'Nenhum registro encontrado',
    page: 'Página:',
    // for dropdown pagination filterBy: 'Filter by {column}',
    // Placeholder for search fields when filtering by column loading:'Loading...',
    // First request to server defaultOption:'Select {column}'
    // default option for list filters }
}

const options = {
    requestFunction: function (data) {
        // data.token = this.$store.getters.token
        return axios.get(this.url, {
            params: data
        }).catch(function (e) {
            this.dispatch('error', e);
            router.push('/login')
        }.bind(this));
    },
    texts: translation,
    pagination: {chunk: 15, dropdown: false, nav: 'scroll'},
    perPage: 10,
    perPageValues: [10, 25, 50, 100]
}

Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(router)
Vue.use(ServerTable, options, true, 'bootstrap3', 'footerPagination')
Vue.use(VueToastr)

//Components
Vue.component('vue-multiselect', Multiselect)
Vue.component('date-picker', VueCtkDateTimePicker);
Vue.component('vue-number-input', VueNumberInput);

export const store = new Vuex.Store(mainStore);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>',
    created() {
        this.$store.dispatch('initialize')
    },
});

//Styles
import './assets/auxiliary/bootstrap/css/bootstrap.min.css'
import '../node_modules/@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
import './assets/css/style.css'
import './assets/auxiliary/animate/animate.css'
import './assets/auxiliary/fontawesome/css/all.min.css'
import '../node_modules/vue-multiselect/dist/vue-multiselect.min.css'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

Vue.prototype.$http = window.axios;
Vue.prototype.$message = function (title, msg, type) {

    let newMsg = '';
    if(msg instanceof Object){

        newMsg += "<ul>";
        for (var key in msg) {
            if (msg.hasOwnProperty(key)) {
                newMsg += "<li>";
                newMsg += msg[key];
                newMsg += "</li>";
            }
        }
        newMsg += "</ul>";

    } else newMsg = msg;

    this.$toastr('add',
        {
            title: title,
            msg: newMsg,
            clickClose: true,
            timeout: 4000,
            position: 'toast-top-right',
            type: type
        })
};

Vue.prototype.$success = function (msg) {
    this.$message('Sucesso', msg, 'success')
};
Vue.prototype.$error = function (msg) {
    this.$message('Erro', msg, 'error')
};

//Moment.js
import '../node_modules/moment/moment'
window.moment = require('moment');
moment.locale('pt-br'); 

axios.interceptors.response.use(
    response => response,
    error => {
        console.log(error.response)
        if (parseInt(error.response.status) === 401 && error.response.data.message == 'Token has expired') {
            let self = this;
            let api = this.$store.state.api + "logout";

            self.$http
                .post(api)
                .then(response => {
                    this.$message("Aviso", "Token expirado", "warning");
                    localStorage.removeItem("token");

                    self.$router.push({ path: "/login" });
                })
                .catch(error => {
                    this.$message("Erro", "Erro ao realizar logout", "error");
                });
        }
        return Promise.reject(error);
    }
)


// WEBPACK FOOTER //
// ./src/main.js